import { Link } from "react-router-dom";

export default function MarketingFooter() {
  return (
    <footer className="border-t" style={{ borderColor: "var(--mk-line)" }}>
      <div className="max-w-screen-xl mx-auto px-5 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 pb-12">
          <div>
            <div className="mk-label mb-4">Product</div>
            <div className="flex flex-col gap-3 text-sm" style={{ color: "var(--mk-muted)" }}>
              <Link to="/how" className="hover:text-[#0e1113] transition-colors">How it works</Link>
              <a href="/#pricing" className="hover:text-[#0e1113] transition-colors">Pricing</a>
              <Link to="/partner/waitlist" className="hover:text-[#0e1113] transition-colors">Partner programme</Link>
            </div>
          </div>
          <div>
            <div className="mk-label mb-4">Company</div>
            <div className="flex flex-col gap-3 text-sm" style={{ color: "var(--mk-muted)" }}>
              <Link to="/contact" className="hover:text-[#0e1113] transition-colors">Contact</Link>
              <Link to="/terms" className="hover:text-[#0e1113] transition-colors">Terms of service</Link>
              <Link to="/privacy" className="hover:text-[#0e1113] transition-colors">Privacy policy</Link>
            </div>
          </div>
          <div>
            <div className="mk-label mb-4">Registered</div>
            <div className="text-sm leading-relaxed" style={{ color: "var(--mk-muted)" }}>
              Input Performance Ltd
              <br />
              England &amp; Wales · ICO ZC036976
            </div>
          </div>
        </div>

        <div
          className="pt-6 border-t flex flex-col md:flex-row md:items-center justify-between gap-4"
          style={{ borderColor: "var(--mk-line)" }}
        >
          <span className="mk-mono text-[11px]" style={{ color: "var(--mk-dim)" }}>
            © {new Date().getFullYear()} Input Performance Ltd
          </span>
          <span className="mk-mono text-[11px]" style={{ color: "var(--mk-dim)" }}>
            Not medical advice — consult your doctor before changing diet or training
          </span>
        </div>
      </div>
    </footer>
  );
}
